export default __webpack_public_path__ + "static/media/journeytray-greentree-fruitnut.d6c41d5b.svg";